<template>
  <div id="taxes_details" class="collapse" data-parent="#services_accordion">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-4">
          <div class="d-flex">
            <input type="text" class="form-control" v-model="inputText" />
            <button @click.prevent="handleSaveData" class="btn btn-submit ripple mb-0">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "Taxes",
  computed: {
    ...mapGetters(["packageTaxes"])
  },
  data() {
    return {
      inputText: this.packageTaxes
    };
  },
  watch: {
    inputText(value) {
      this.setInputTextData({ value, type: "visa" });
    }
  },
  created() {
    this.inputText = this.packageTaxes;
  },
  methods: {
    ...mapActions(["updatePackage"]),
    ...mapMutations(["setInputTextData"]),
    handleSaveData() {
      this.updatePackage({
        type: "ADVANCE",
        data: {
          advance: {
            code: this.$route.query.code,
            data: { taxes: this.inputText }
          }
        }
      }).then(() => {
        this.$toasted.success("Taxes Details Is Updated", {
          position: "bottom-center",
          duration: 5000
        });
      });
    }
  }
};
</script>
<style scoped>
.btn-submit {
  overflow: inherit;
  padding: 6px;
  height: 34px;
  width: 80px;
  margin-left: 0;
}
</style>
